<p-dialog
  *ngIf="displayEntitySelectionDialog"
  [header]="displayName + ' auswählen'"
  [modal]="true"
  [(visible)]="displayEntitySelectionDialog"
  [style]="{ width: '80%' }"
  appendTo="body"
>
  <jml-lib-dynamic-table
    *ngIf="entitySelectionTableData"
    [tableData]="entitySelectionTableData"
    (entitySelection)="entitySelected($event)"
    [isRootEntity]="false"
  ></jml-lib-dynamic-table>
</p-dialog>

<div class="flex">
  <div class="w-full">
    <span [ngClass]="{ 'p-float-label': showFloatLabel }">
      <input
        #referenceInput
        readonly
        class="cursor-pointer w-full"
        pInputText
        jmlLibReferenceRepr="_repr_"
        [formControl]="control"
        autocomplete="off"
        [placeholder]="showFloatLabel ? '' : placeholder"
        (keyup.Space)="openEntitySelectionDialog(referenceInput)"
        (click)="openEntitySelectionDialog(referenceInput)"
        [class.ng-invalid]="mandatory && !control.value"
      />
      <label *ngIf="!!placeholder && showFloatLabel" [for]="referenceInput.id">{{ placeholder }}</label>
    </span>
  </div>
  <button
    *ngIf="showDelete"
    pButton
    tabindex="-1"
    type="button"
    class="ml-1"
    (click)="onClickDelete()"
    icon="pi pi-times"
  ></button>
  <ng-content></ng-content>
</div>
